import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from 'src/app/platform.service';
import { DataService } from 'src/app/services/data.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';
import { PaymentsPage } from '../payments/payments.page';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-get-locker',
  templateUrl: './get-locker.page.html',
  styleUrls: ['./get-locker.page.scss'],
})
export class GetLockerPage implements OnInit {
  loaded=false;
  width = window.innerWidth;

  @Input() areaID:any
  lockerArea: any = {};
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    private modalCtrl: ModalController,
    public platformSRV:PlatformService,
    private toasterSRV:ToastService,
    private loaderSRV:LoaderService,
    public modalController: ModalController,
    public dataService: DataService,
    public translateService: TranslateService,
  ) { }
  async closeModal() {
  
    this.modalController.dismiss()
    
   }
  ngOnInit() {
    const url = `lockers/area/${this.areaID}`;
    this.dataService.getData(url).subscribe((res) => {
      var taxes=[]
        for (var i = 0; i < Object.entries(res['totals']['taxes']).length; i++)
      {
        taxes.push( Object.entries(res['totals']['taxes'])[i][1])
        
      }
      res['totals']['taxes'] = taxes
     this.loaded=true
      this.lockerArea = res;
    });
  }
  onReserveLocker(lockerId) {
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.lockers.reserving_locker') || 'Reserving locker...')
    const url = `lockers/area/${lockerId}/reserve`;
    this.dataService
      .postData(url, { lockerid: lockerId })
      .subscribe({
        next:async (res:any)=>{
          if(res['status']=="success"){
            this.toasterSRV.presentToast(this.translateService.instant('keys.data.lockers.locker_added') || 'Locker Reserved Successfully')
            this.loaderSRV.dismissLoader()
            this.modalController.dismiss()
            const desktopModal = await this.modalCtrl.create({
              component: PaymentsPage,
              breakpoints: [0.5, 0.8,1],
             
              cssClass: 'modal-desktop-long',
             
            });
            const mobileModal = await this.modalCtrl.create({
              component: PaymentsPage,
              breakpoints: [0.5, 0.8,1],
              initialBreakpoint: 1,
              cssClass:"modal-mobile-normal",
             
            })
            const tabletModal = await this.modalCtrl.create({
              component: PaymentsPage,
              breakpoints: [0.5, 0.8,1],
              initialBreakpoint: 1, 
              cssClass:"modal-tablet-normal",
             
            })
            var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
            modal.present()
          } else {
            if(res?.message){
              this.toasterSRV.presentErrorToast(res?.message)
            }
            this.loaderSRV.dismissLoader()
          }
        },
        error:err=>{
          this.errorHandlerSRV.displayErrorMessage(err,true)
        }
        
       
      });
  }
}
